import { Properties } from "../properties.js";
/**
 * The properties stream contained inside an Recipient storage object.
 */
export class RecipientProperties extends Properties {
    writeProperties(storage, prefix, messageSize) {
        const recipPropPrefix = (buf) => {
            prefix(buf);
            // Reserved(8 bytes): This field MUST be set to zero when writing a .msg file and MUST be ignored
            // when reading a.msg file.
            buf.writeUint64(0);
        };
        return super.writeProperties(storage, recipPropPrefix, messageSize);
    }
}
